import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    daysContainer: (color: string) => ({
      backgroundColor: color,
      '& .MuiTypography-root': {
        color: colors.color5
      },
      borderRadius: '50px',
      padding: 1,
      textAlign: 'center'
    }),
    flex: {
      display: 'flex'
    }
  }
}
